

import { Component, Vue } from "vue-property-decorator";
import user_module from '@/modules/user/index';
import Product from './product.vue'

@Component({
  components: {
    Product
  }
})

export default class FreeProducts extends Vue {


  get freeProducts(){

    return user_module.userProducts.filter(product => !product.main && product.free && !product.hide);

  }

}

